export default [
  {
    name: 'Los Angeles',
    long: -118.256243,
    lat: 34.044949,
    orientation: 'right',
  },
  // {
  //   name: 'San Diego',
  //   long: -117.148962,
  //   lat: 32.69247,
  //   orientation: 'left',
  // },
  // {
  //   name: 'Sacramento',
  //   long: -121.494444,
  //   lat: 38.581667,
  //   orientation: 'right',
  // },
  // {
  //   name: 'San Francisco',
  //   long: -122.416389,
  //   lat: 37.7775,
  //   orientation: 'left',
  // },
  // {
  //   name: 'Redding',
  //   long: -122.366667,
  //   lat: 40.583333,
  //   orientation: 'right',
  // },
  {
    name: 'Fresno',
    long: -119.766667,
    lat: 36.75,
    orientation: 'right',
  },
  {
    name: 'Las Vegas',
    long: -115.136389,
    lat: 36.175,
    orientation: 'right',
  },
  {
    name: 'Denver',
    long: -104.985,
    lat: 39.7392,
    orientation: 'right',
  },
  // {
  //   name: 'Salt Lake City',
  //   long: -111.891111,
  //   lat: 40.760833,
  //   orientation: 'right',
  // },
  // {
  //   name: 'Austin',
  //   long: -97.743056,
  //   lat: 30.267222,
  //   orientation: 'right',
  // },
];
